import * as React from "react";
import { notification, Button, Tooltip } from "antd";
import { useState, useContext, useEffect } from "react";
import { withRouter, RouteComponentProps, Link } from "react-router-dom";
import { AuthContext } from "src/components/context/AuthContext";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";

import DataGrid, { Column, Pager, Paging, FilterRow, HeaderFilter } from "devextreme-react/data-grid";
import { ServiceContext } from "src/services/provider/Service.provider";

function UserList(
  props: {
    style?: React.CSSProperties;
    pageSize?: number;
    max?: number;
  } & RouteComponentProps<any>
) {
  const { userService } = useContext(ServiceContext);
  const { currentUser } = React.useContext(AuthContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch();
  }, []);

  async function fetch(params = {}) {
    setLoading(true);

    try {
      const users = await userService.getAll();
      const usersDto = users.map(user => {
        const dto = Object.assign({}, user) as any;
        dto.active = user.active ? "Ativo" : "Inativo";
        return dto;
      });
      setData(usersDto);
    } catch (error) {
      notification.error({
        message: "Falha na consulta",
        description: "Ocorreu um erro durante a consulta. Tente novamente."
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <PbrCard title={"Usuários"} bordered={false} style={{ width: "100%" }}>
      <DataGrid
        dataSource={data}
        allowColumnReordering={true}
        showBorders={true}
        loadPanel={{ enabled: loading }}
        rowAlternationEnabled={true}
        hoverStateEnabled={true}
        columnAutoWidth={true}
      >
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />

        <Column
          caption="#"
          alignment={"center"}
          width={"60px"}
          cellRender={params => {
            let isEditDisallowed = false;
            if (params.data.profiles.length > 0) {
              params.data.profiles.map(e => {
                if (e.name === "Officer_Master" || currentUser.login === params.data.login) {
                  isEditDisallowed = true;
                }
              });
            }

            return (
              <Tooltip title={isEditDisallowed ? "" : "Editar Usuário"}>
                <Link to={`/usuarios/${params.data.id}`}>
                  {" "}
                  <Button disabled={isEditDisallowed} icon="edit" />{" "}
                </Link>
              </Tooltip>
            );
          }}
        />

        <Column caption="ID" alignment={"center"} dataField="id" dataType="number" width={"80px"} />
        <Column caption="Name" alignment={"center"} dataField="fullName" dataType="string" />
        <Column caption="Document" alignment={"center"} dataField="cpfCnpj" dataType="string" />
        <Column caption="Mail" alignment={"center"} dataField="login" dataType="string" />
        <Column caption="Phone" alignment={"center"} dataField="phoneNumber" dataType="string" />
        <Column caption="Is Active" dataField="active" dataType="string" alignment="center" />
        <Column caption="Officer" dataField="officer.name" dataType="string" alignment="center" />
        <Column
          caption="Profiles"
          alignment={"center"}
          width={"120px"}
          cellRender={params => {
            return <>{`${params.data.profiles.length > 0 ? params.data.profiles.map(e => e.name).join(",") : ""}`}</>;
          }}
        />

        <Pager allowedPageSizes={[10, 25, 50, 100]} showPageSizeSelector={true} />
        <Paging defaultPageSize={10} />
      </DataGrid>
    </PbrCard>
  );
}

export default withRouter(UserList);



// WEBPACK FOOTER //
// ./src/pages/manager/users/UserList.tsx